export const LOCALSTORAGE_TOKEN = "just-eats-token";
export const IS_VERIFIED = "is-verified";
